<template>
  <ProductContentDetails
    :offer="offer"
    headline="Technische Details"
    class="feature-list"
  >
    <template #default="props">
      <Charger
        v-if="props.product?.commonCharger?.possible"
        class="feature-list__charger"
        :common-charger="props.product.commonCharger"
      />
      <TechnicalDetails
        :features="getFeatures(props.product)"
        :documents="documents"
      />
    </template>
  </ProductContentDetails>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import ProductContentDetails from '~/components/product-detail/tabs/product-content-details.vue';
import TechnicalDetails from '~/components/product-detail/tabs/technical-details.vue';
import { Charger } from '@i22/td-longtail-vue-components';
import { getStandardProduct, type Offer, type OfferProduct } from '~/lib/goliath/offer-by-slugs';

export default defineComponent({
  name: 'FeatureList',
  components: {
    ProductContentDetails,
    TechnicalDetails,
    Charger,
  },
  props: {
    offer: {
      type: Object as PropType<Offer>,
      required: true,
    },
  },
  computed: {
    // documents are on the Offer, features on the Product!
    documents() {
      return this.offer?.documents || [];
    },
  },
  methods: {
    getFeatures(product: OfferProduct) {
      const features: { name: string; value: any }[] = [];
      if (product.eans) {
        features.push({
          name: 'GTIN',
          value: product.eans.join(', '),
        });
      }

      const standardProduct = getStandardProduct(product);
      if (standardProduct) {
        standardProduct.features?.forEach((f) => {
          if (f?.name && f.value !== undefined && f.value !== null) {
            features.push({
              name: f.name,
              value: f.value,
            });
          }
        });
      }

      return features;
    },
  },
});
</script>

<style lang="scss" scoped>
.feature-list {
  &__charger {
    font-size: 5em;
  }
}
</style>
